import React from 'react';
import {Route, Switch} from 'react-router-dom';
import AboutMe from '../Pages/AboutMe'
import Projects from '../Pages/Projects'
import Skills from '../Pages/Skills'
import Contact from '../Pages/Contact'
import Error from '../Pages/ErrorPage'
const Page = () => {
    return ( 
        <Switch>
            <Route path="/My-portfolio" exact component={AboutMe}/>
            <Route path="/My-portfolio/projects" component={Projects}/>
            <Route path="/My-portfolio/projects" component={Projects}/>
            <Route path="/My-portfolio/skills" component={Skills}/>
            <Route path="/My-portfolio/Contact" component={Contact}/>
            <Route path="/projects" component={Projects}/>
            <Route path="/projects" component={Projects}/>
            <Route path="/skills" component={Skills}/>
            <Route path="/Contact" component={Contact}/>
            <Route component={Error}/>
        </Switch>
     );
}
 
export default Page;